var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress_bar"},[_c('div',{staticClass:"active",style:(`width: ${_vm.formatedWidth}%;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }